// extracted by mini-css-extract-plugin
module.exports = {"noScrolling":"Video_noScrolling__x4euw","video":"Video_video__0WSTo","disabled":"Video_disabled__DH8OQ","play":"Video_play__NuScL"};